export const AddMetadataDistinctValueSelectionFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AddMetadataDistinctValueSelection' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentMetadataProperty' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMultiSelect' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                ],
            },
        },
    ],
};
export const MetadataListSelectionDistinctValuesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'MetadataListSelectionDistinctValues' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyName' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'distinctValues' },
                        name: { kind: 'Name', value: 'documentMetadataPairsDistinctValuesForProperty' },
                        arguments: [
                            { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '5000' } },
                            { kind: 'Argument', name: { kind: 'Name', value: 'offset' }, value: { kind: 'IntValue', value: '0' } },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'propertyName' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyName' } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
